import React from 'react';
import Chart from './Chart';
import HighRiskCard from './HighRiskCard';
import SourcesCard from './SourcesCard';

const DetectionTypesSection = ({site}) => {

  return (
    <>
      <h4 className="section-header">Detection types</h4>
      <div className="detection-types section-box">
        <Chart site={site} />
        <HighRiskCard site={site} />
        <SourcesCard site={site} />
      </div>
    </>
  );
}

export default DetectionTypesSection;
